import { combineReducers } from "redux";

import loaderSlice from "./loader";
import roleSlice from "./role";

const appReducer = combineReducers({
  loader: loaderSlice,
  role: roleSlice,
});
export default appReducer;
